<label class="custom-value" [class.has-edit-icon]="showEditIcon" [class.has-value]="value.trim()">
  <mat-icon class="custom-icon" *ngIf="showEditIcon">edit</mat-icon>
  <input
    type="text"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [value]="value"
    (input)="updateValue($event)"
    (keyup.enter)="submit()" />
  <fastr-ui-voice-dictation
    *ngIf="showVoiceIcon"
    size="compact"
    [disabled]="disabled"
    (transcript)="appendTranscript($event)">
  </fastr-ui-voice-dictation>
  <button
    *ngIf="showSubmitButton"
    type="button"
    class="submit-button"
    aria-label="Send"
    [disabled]="disabled || !value.trim()"
    (click)="submit()">
    <span class="send-icon" aria-hidden="true"></span>
  </button>
</label>
